module.exports = __webpack_public_path__ + "static/img/impression_ttl.a508e15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/impression_ttl.svg
// module id = Ni1l
// module chunks = 0